import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * The admin app is English only and its own texts aren't translated. Transloco is here only because the `ui-platform`
 * components translate their labels: these are the keys they use by default, any other text is shown as it is.
 */
const ADMIN_TRANSLATION: Translation = {
  'general.cancel': 'Cancel',
  'general.change': 'Change',
  'general.save': 'Save',
  'general.select-placeholder': 'Select one'
};

@Injectable({ providedIn: 'root' })
export class AdminTranslocoLoader implements TranslocoLoader {
  getTranslation(): Observable<Translation> {
    return of(ADMIN_TRANSLATION);
  }
}
